import { css } from '@emotion/react';
import { CallIntelChip, useCallIntelDefaultsShallowStore } from '@frontend/call-intel-core';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

type ExpiredTrialStatCardType = 'needs-attention' | 'revenue-at-risk' | 'scheduling-rate';

type ExpiredTrialStatCardProps = {
  title: string;
  value: number | string;
  description: string;
  type: ExpiredTrialStatCardType;
};

const dataKeyMap: Record<ExpiredTrialStatCardType, string> = {
  'needs-attention': 'SENTIMENT_NEGATIVE',
  'revenue-at-risk': 'SCHEDULING_OUTCOME_UNSCHEDULED',
  'scheduling-rate': 'SCHEDULING_OUTCOME_SCHEDULED',
};

export const ExpiredTrialStatCard = ({ title, value, description, type }: ExpiredTrialStatCardProps) => {
  const { chipVariants } = useCallIntelDefaultsShallowStore('chipVariants');

  return (
    <div css={styles.card}>
      <Text weight='bold' size='small'>
        {title}
      </Text>

      <div css={styles.metric}>
        <CallIntelChip chipVariants={chipVariants} dataKey={dataKeyMap[type]} />
        <Heading level={1} css={styles.value}>
          {value}
        </Heading>
        <Text color='subdued' size='small'>
          {description}
        </Text>
      </div>
    </div>
  );
};

const styles = {
  card: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    padding: ${theme.spacing(1.5)};
    background: ${theme.colors.white};
    border-radius: ${theme.borderRadius.small};
    box-shadow: ${theme.shadows.light};
  `,
  value: css`
    font-size: ${theme.fontSize(32)};
    line-height: ${theme.spacing(5)};
  `,
  metric: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
};
